module.exports = __webpack_public_path__ + "static/media/Quantum.6f206b2c.otf";